/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Agents_P_Json_TitleInputs */

const en_cad_agents_p_json_title = /** @type {(inputs: Cad_Agents_P_Json_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON control channel`)
};

/**
* | output |
* | --- |
* | "JSON control channel" |
*
* @param {Cad_Agents_P_Json_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_agents_p_json_title = /** @type {((inputs?: Cad_Agents_P_Json_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Agents_P_Json_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_agents_p_json_title(inputs)
});
export { cad_agents_p_json_title as "cad.agents.p_json_title" }